// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo-h1 {
    font-weight: 600;
}

.demo-p {
    font-weight: 500;
}

.demo-img {
    width: 30%;
}

.demo-header {
    height: 80px;
    box-shadow: 3px 3px 3px #ddd;
    background: #FDFBFB;
    display: flex;
    padding: 0.375rem 0;
    flex: 0 0 63px;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
}

.demo-header img {
    width: 200px;
    margin-left: auto;
    margin-right: auto;
}

.demo-header .medispace {
    width: 300px;
    margin-left: auto;
    margin-right: auto;
}

.demo-label {
    font-weight: 600;
    margin-right: 10px;
}

.demo-input {
    border-radius: 10px;
    border: 1px solid #ccc;
    color: #00666F;
    padding: 2px 20px;
    width: 250px;
}

.demo-button {
    border-radius: 20px;
    border: 0px;
    padding: 13px;
    background-color: #1DADB5;
    color: #fff;
    font-weight: 600;
    width: 250px;
}

.demo-span {
    font-size: 14px;
    font-weight: 600;
    color: #007E94;
}

.demo-a {
    color: #F4981C;
}

.demo-mainframe {
    max-width: 1200px;
    text-align: center;
    margin: auto;
    background-color: #FDFBFB;
    margin-top: 50px;
    padding: 15px 15px 40px 15px;
    border-radius: 15px;
    box-shadow: 3px 3px 3px #ddd;
    hyphens: auto;
}

.demo-border {
    border: solid 2px #F4981C;
    border-radius: 20px;
    width: 60%;
    margin-left: auto;
    margin-right: auto;
    padding: 10px;
}

.demo-back {
    border: solid 1px #00666F;
    background-color: #fff;
    color: #00666F;
    width: 180px;
}`, "",{"version":3,"sources":["webpack://./src/Demo.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,YAAY;AAChB","sourcesContent":[".demo-h1 {\n    font-weight: 600;\n}\n\n.demo-p {\n    font-weight: 500;\n}\n\n.demo-img {\n    width: 30%;\n}\n\n.demo-header {\n    height: 80px;\n    box-shadow: 3px 3px 3px #ddd;\n    background: #FDFBFB;\n    display: flex;\n    padding: 0.375rem 0;\n    flex: 0 0 63px;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: row;\n}\n\n.demo-header img {\n    width: 200px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.demo-header .medispace {\n    width: 300px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.demo-label {\n    font-weight: 600;\n    margin-right: 10px;\n}\n\n.demo-input {\n    border-radius: 10px;\n    border: 1px solid #ccc;\n    color: #00666F;\n    padding: 2px 20px;\n    width: 250px;\n}\n\n.demo-button {\n    border-radius: 20px;\n    border: 0px;\n    padding: 13px;\n    background-color: #1DADB5;\n    color: #fff;\n    font-weight: 600;\n    width: 250px;\n}\n\n.demo-span {\n    font-size: 14px;\n    font-weight: 600;\n    color: #007E94;\n}\n\n.demo-a {\n    color: #F4981C;\n}\n\n.demo-mainframe {\n    max-width: 1200px;\n    text-align: center;\n    margin: auto;\n    background-color: #FDFBFB;\n    margin-top: 50px;\n    padding: 15px 15px 40px 15px;\n    border-radius: 15px;\n    box-shadow: 3px 3px 3px #ddd;\n    hyphens: auto;\n}\n\n.demo-border {\n    border: solid 2px #F4981C;\n    border-radius: 20px;\n    width: 60%;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 10px;\n}\n\n.demo-back {\n    border: solid 1px #00666F;\n    background-color: #fff;\n    color: #00666F;\n    width: 180px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
